import { Component } from '@verndale/core';
import axios from 'axios';

import { COURSELEAF_API_URL } from '../utils/url';
import { triggerCustomEvent } from '../utils/events';

class CourseLeaf extends Component {
  setupDefaults() {
    this.dom = {
      $links: this.el._$$('a[data-api-course]'),
      $modal: this.el._$('.modal'),
      $modalContent: this.el._$('.modal__content')
    };
  }

  addListeners() {
    this.el._on('click', ::this.showCourseInfo);
  }

  showCourseInfo(e) {
    const target = e.target.closest('a[data-api-course]');

    if (target) {
      e.preventDefault();
      this.getCourseInfo(target.dataset.apiCourse, target);
    }
  }

  async getCourseInfo(course, trigger) {
    try {
      const { data } = await axios({
        method: 'get',
        url: COURSELEAF_API_URL,
        params: {
          course
        }
      });
      if (data) {
        this.triggerOpenModal(data, trigger);
      }
    } catch (error) {
      console.error(error);
    }
  }

  triggerOpenModal(content, trigger) {
    this.dom.$modalContent.innerHTML = content;
    const eventInit = {
      detail: { trigger }
    };
    triggerCustomEvent(this.dom.$modal, 'openModal', eventInit);
  }
}

export default CourseLeaf;
